import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronRight, Home } from 'lucide-react';

export default function PublicHeader({ breadcrumbs = [] }) {
  const navigate = useNavigate();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <div 
            className="flex items-center gap-2 sm:gap-3 cursor-pointer"
            onClick={() => navigate('/')}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_courts-module/artifacts/ttoifebz_twenty-docs-logo-small.jpg"
              alt="TwentyDocs"
              className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg"
            />
            <div>
              <span className="text-lg sm:text-2xl font-bold gradient-text block leading-tight">TwentyDocs</span>
              <span className="text-[8px] sm:text-[9px] text-slate-500 block leading-tight -mt-0.5">
                A Twenty Digital Product
              </span>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-6">
            <button 
              onClick={() => navigate('/how-it-works')} 
              className="text-sm font-medium text-slate-600 hover:text-violet-600 transition-colors"
            >
              How it works?
            </button>
            <button 
              onClick={() => navigate('/pricing')} 
              className="text-sm font-medium text-slate-600 hover:text-violet-600 transition-colors"
            >
              Pricing
            </button>
            <button 
              onClick={() => navigate('/contact')} 
              className="text-sm font-medium text-slate-600 hover:text-violet-600 transition-colors"
            >
              Contact
            </button>
          </div>

          {/* Auth Buttons */}
          <div className="flex items-center gap-2 sm:gap-4">
            <Button
              variant="ghost"
              onClick={() => navigate('/auth')}
              className="hidden sm:flex rounded-full font-medium text-sm sm:text-base"
            >
              Log in
            </Button>
            <Button
              onClick={() => navigate('/auth')}
              className="h-9 px-4 sm:h-11 sm:px-6 rounded-full bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 text-white font-bold shadow-lg hover:shadow-xl transition-all duration-300 text-sm sm:text-base"
            >
              <span className="hidden sm:inline">Get Started</span>
              <span className="sm:hidden">Start</span>
              <ChevronRight className="ml-1 sm:ml-2 w-3 h-3 sm:w-4 sm:h-4" />
            </Button>
          </div>
        </div>
      </div>
      
      {/* Breadcrumbs */}
      {breadcrumbs.length > 0 && (
        <div className="bg-slate-50/50 border-t border-slate-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-2 sm:py-3">
            <div className="flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm">
              <button 
                onClick={() => navigate('/')}
                className="flex items-center gap-1 text-slate-600 hover:text-violet-600 transition-colors"
              >
                <Home className="w-3 h-3 sm:w-4 sm:h-4" />
                <span className="hidden sm:inline">Home</span>
              </button>
              {breadcrumbs.map((crumb, index) => (
                <div key={index} className="flex items-center gap-1.5 sm:gap-2">
                  <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4 text-slate-400" />
                  {crumb.link ? (
                    <button 
                      onClick={() => navigate(crumb.link)}
                      className="text-slate-600 hover:text-violet-600 transition-colors"
                    >
                      {crumb.label}
                    </button>
                  ) : (
                    <span className="text-slate-900 font-medium">{crumb.label}</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
